import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MojoTalentPoolsService, TalentPool, TalentPoolsCandidates } from 'mojo-talent-pools';
import { Observable } from 'rxjs';
import { Pagination } from '../models/pagination';
import { Candidate } from '../models/candidate';
import { BarChartData } from '../models/bar-chart';

@Injectable({
  providedIn: 'root',
})
export class TalentPoolsService extends ApiService implements MojoTalentPoolsService {
  constructor() {
    super();
    this.url = 'talent-pools/';
  }

  talentPoolWithDetails(id: number): Observable<TalentPool> {
    return this.get({ url: `${id}` });
  }

  changeTalentPoolCandidateStatus(
    talentPoolId: number,
    candidateId: number,
    body: { statusName: string },
  ): Observable<Candidate> {
    return this.patch({ url: `${talentPoolId}/candidates/${candidateId}?assign-status`, body });
  }

  addCandidatesToTalentPools(body: TalentPoolsCandidates): Observable<TalentPool[]> {
    return this.post({ url: 'candidates', body });
  }

  countCandidatesInPool(talentPoolId: number): Observable<number> {
    return this.get({
      url: `candidates/count-all`,
      params: { talentPoolId: talentPoolId.toString() },
    });
  }

  getTalentPoolsForExternalCandidate(id: string, page: number): Observable<Pagination<TalentPool>> {
    return this.get({ url: `candidates/${id}`, params: { page, size: 9 } });
  }

  getStatusesByCandidateIdAndTalentPoolIds(
    candidateId: string,
    talentPoolIds: number[],
  ): Observable<{ talentPoolId: number; status: string }[]> {
    return this.get({
      url: `candidates/${candidateId}/statuses`,
      params: {
        talentPoolIds: talentPoolIds.join(','),
      },
    });
  }

  getBarChartData(talentPoolId: number): Observable<BarChartData> {
    return this.get({ url: `project/chart?talentPoolId=${talentPoolId}` });
  }
}
